<template>
  <div class="authority-manage position-header">
    <navHeader :titleList="['配对会列表']"/>
    <div class="rhBrand-content common-padding">
      <el-card class="box-card">
        <el-row :gutter="20">
          <el-col :span="4">
            <el-input v-model.trim="title" placeholder="请输入标题" clearable size="small"></el-input>
          </el-col>
          <el-col :span=5>
            <el-button @click="search" class="btn-search" round icon="el-icon-search" size="small">查询
            </el-button>
            <el-button @click="reset" type="warning" round icon="el-icon-refresh" size="small">重置
            </el-button>
          </el-col>
          <el-col :span="15">
            <div style="float: right">
              <el-button  @click="backTopic" type="primary" icon="el-icon-back" size="small">返回配对会主题
              </el-button>
            </div>
          </el-col>
        </el-row>
      </el-card>
      <el-card class="box-card flex-1 table-card">
<!--        <el-button class="btns-add" icon="el-icon-plus" size="medium" @click="add">添加-->
<!--        </el-button>-->
        <el-row class="common-margin flex-1 table-main">
          <el-table :data="tableData" class="flex-1" stripe height="100%" style="width: 100%" border>
            <el-table-column type="index" width="80px" align="center" label="序号" fixed></el-table-column>
            <el-table-column prop="activityType" align="center" label="类型" show-overflow-tooltip>
              <template slot-scope="scope">
                <div>{{scope.row.activityType === '1' ? '品牌' : '展商'}}</div>
              </template>
            </el-table-column>
            <el-table-column prop="title" align="center" label="标题" show-overflow-tooltip></el-table-column>
            <el-table-column prop="posterUrl" align="center" label="封面海报地址" width="180">
              <template slot-scope="scope">
                <el-image v-if="scope.row.posterUrl" style="height: 100px" :src="scope.row.posterUrl"
                          :preview-src-list="[scope.row.posterUrl]" fit="contain"
                ></el-image>
              </template>
            </el-table-column>
            <el-table-column prop="startTime" align="center" label="开始时间" show-overflow-tooltip></el-table-column>
            <el-table-column prop="endTime" align="center" label="结束时间" show-overflow-tooltip></el-table-column>
            <el-table-column prop="shelfStatus" align="center" label="是否上下架" show-overflow-tooltip>
              <template slot-scope="scope">
                {{ scope.row.shelfStatus ? (scope.row.shelfStatus === '1' ? '是' : '否') : '' }}
              </template>
            </el-table-column>
            <el-table-column prop="introduce" align="center" label="简介" show-overflow-tooltip></el-table-column>
            <el-table-column align="center" label="操作" width="100">
              <template slot-scope="scope">
                <div class="btn-box">
<!--                  <el-button-->
<!--                      v-if="scope.row.activityType === '1'"-->
<!--                      icon="el-icon-document"-->
<!--                      type="primary"-->
<!--                      size="small"-->
<!--                      @click="checkMeetSession(scope.row.id, scope.row.activityType)"-->
<!--                  >参与配对会报名列表-->
<!--                  </el-button>-->
                  <el-button
                      icon="el-icon-document"
                      type="text"
                      size="small"
                      @click="application(scope.row.id, scope.row.activityType, scope.row.startTime, scope.row.endTime)"
                  >配对会报名
                  </el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
              @current-change="handleCurrentChange"
              @size-change="handleSizeChange"
              :current-page.sync="currentPage"
              :page-size="pageSize"
              layout="total, prev, pager, next, sizes"
              :total="total"
          >
          </el-pagination>
        </el-row>
      </el-card>
    </div>

    <el-dialog class="exhibition-dialog" width="70%" :visible.sync="meetVisible" :close-on-click-modal="false" @close="closeSession">
      <SessionList ref="sessionListRef" v-if="isList" @isShowDetail="isShowDetail" />
      <SessionDetail ref="sessionDetailRef" v-else @isShowList="isShowList" />
    </el-dialog>

    <el-dialog class="exhibition-dialog" width="70%" :close-on-click-modal="false" :visible.sync="outerVisible">
      <bannerAndAdvertIndex ref="bannerAndAdvertIndex" @isShowActivity="isShowActivity" :isShowEnroll="isShowEnroll" />
      <el-dialog
          class="exhibition-dialog"
          width="70%"
          :close-on-click-modal="false"
          :visible.sync="innerVisible"
          append-to-body>
        <activityList v-if="innerVisible" ref="activityList" :activityId="activityId" @updateList="updateList" :listType="listType" />
      </el-dialog>
    </el-dialog>

    <el-dialog width="40%" :close-on-click-modal="false" :visible.sync="applicationVisible">
      <el-form :model="applicationForm" :rules="applicationRules" ref="applicationRef" label-width="120px" class="add-form">
        <el-form-item prop="contacts" label="联系人：">
          <el-input v-model.trim="applicationForm.contacts"></el-input>
        </el-form-item>
        <el-form-item prop="phone" label="手机号：">
          <el-input v-model.trim="applicationForm.phone"></el-input>
        </el-form-item>
        <el-form-item prop="email" label="说明：">
          <el-input v-model.trim="applicationForm.email" type="textarea" :rows="6"></el-input>
        </el-form-item>
        <div class="info-footer">
          <el-button @click="cancel">取 消</el-button>
          <el-button type="primary" @click="save">确 定</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import navHeader from '../../components/navHeader'
import SessionList from './sessionList.vue'
import SessionDetail from './sessionDetail.vue'
import bannerAndAdvertIndex from './bannerAndAdvertIndex'
import activityList from './activityList'

export default {
  name: 'meetSession',
  data () {
    return {
      id: '',
      meetId: '',
      activityType: '',
      meetSessionId: '',
      exportLoading: false,
      type: '',
      title: '',
      status: '',
      tableData: [],
      tableHeight: 0,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      applicationVisible: false,
      applicationForm: {
        sessionId: '',
        phone: '',
        contacts: '',
        email: ''
      },
      applicationRules: {
        phone: {
          required: true,
          message: '请填写手机号码',
          trigger: 'blur'
        },
        contacts: {
          required: true,
          message: '请填写联系人',
          trigger: 'blur'
        },
        email: {
          required: true,
          message: '请填写说明',
          trigger: 'blur'
        }
      },
      meetVisible: false,
      isList: true,
      outerVisible: false,
      isShowEnroll: false,
      innerVisible: false,
      activityId: '',
      listType: ''
    }
  },
  components: {
    navHeader,
    SessionList,
    SessionDetail,
    bannerAndAdvertIndex,
    activityList
  },
  created () {
    this.tableHeight = document.documentElement.clientHeight - 360
    this.getPageList()
  },
  methods: {
    async getPageList () {
      this.meetId = this.$route.query.meetId ? this.$route.query.meetId : ''
      let {data: res} = await this.$http.post('/meetSession/meetSession/getMeetSessionList', {
        meetId: this.meetId,
        title: this.title,
        currentPage: this.currentPage,
        pageSize: this.pageSize
      })
      if (res.code === '200') {
        this.tableData = res.data.records
        this.total = parseInt(res.data.total)
      }
    },
    search () {
      this.currentPage = 1
      this.getPageList()
    },
    reset () {
      this.title = ''
      this.type = ''
      this.status = ''
      this.currentPage = 1
      this.getPageList()
    },
    backTopic () {
      this.$router.push('/mateMeetTopic')
    },
    checkMeetSession (id, type) {
      this.meetVisible = true
      this.meetSessionId = id
      this.activityType = type
      this.$nextTick(() => {
        this.$refs.sessionListRef.getPageList(id, type)
      })
    },
    async application (id, type, startTime, endTime) {
      let now = new Date()
      let end = new Date(endTime)
      if (now > end) return this.$message.warning('活动报名已截止!')
      if (type === '2') {
        this.applicationForm.sessionId = id
        this.applicationVisible = true
      } else {
        this.outerVisible = true
        this.activityId = id
        this.listType = type
        this.isShowEnroll = now < end
        this.$nextTick(() => {
          this.$refs.bannerAndAdvertIndex.getPageList(id)
        })
      }
    },
    add () {
      this.$router.push({
        name: 'MeetSessionDetail',
        params: {meetId: this.meetId, type: 'add'}
      })
    },
    edit (id) {
      this.$router.push({
        name: 'MeetSessionDetail',
        params: {id, type: 'edit'}
      })
    },
    upOrDown (id, shelfStatus) {
      let tip = ''
      let status = ''
      if (!shelfStatus || shelfStatus === '2') {
        tip = '确定上架?'
        status = '1'
      } else {
        tip = '确定下架?'
        status = '2'
      }
      this.$confirm(tip, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        closeOnClickModal: false,
        showClose: false
      }).then(() => {
        this.$http
          .post('/meetSession/meetSession/modifyShelfStatus', {id, shelfStatus: status})
          .then((res) => {
            if (res.data.code === '200') {
              this.$message.success(res.data.msg)
              this.getPageList()
            } else {
              this.$message.error(res.data.msg)
            }
          })
          .catch(() => {
          })
      })
    },
    // 分页
    handleCurrentChange (page) {
      this.currentPage = page
      this.getPageList()
    },
    handleSizeChange (size) {
      this.pageSize = size
      this.getPageList()
    },
    handleDelete (id) {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '删除提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        closeOnClickModal: false,
        showClose: false
      }).then(() => {
        this.$http.post('/meetSession/meetSession/batchDelete', {ids: id}).then(res => {
          if (res.data.code === '200') {
            this.$message.success(res.data.msg)
            this.getPageList()
          } else {
            this.$message.error(res.data.msg)
          }
        }).catch(() => {
          this.$message({
            type: 'error',
            message: '删除失败'
          })
        })
      })
    },
    isShowDetail (id) {
      this.isList = false
      this.$nextTick(() => {
        this.$refs.sessionDetailRef.getDetail(id)
      })
    },
    isShowList () {
      this.isList = true
      this.$nextTick(() => {
        this.$refs.sessionListRef.getPageList(this.meetSessionId, this.activityType)
      })
    },
    closeSession () {
      this.isList = true
    },
    isShowActivity () {
      this.innerVisible = true
    },
    updateList () {
      this.$refs.bannerAndAdvertIndex.getPageList(this.activityId)
    },
    cancel () {
      this.applicationVisible = false
      this.applicationForm = {
        sessionId: '',
        phone: '',
        contacts: '',
        WeChat: '',
        email: ''
      }
    },
    save () {
      this.$refs.applicationRef.validate((val) => {
        if (val) {
          this.$http.post('/meetSession/meetSession/addActivityRegistrationCompany', {...this.applicationForm}).then(res => {
            if (res.data.code === '200') {
              this.$message.success(res.data.msg)
              this.getPageList()
              this.applicationVisible = false
              this.applicationForm = {
                sessionId: '',
                phone: '',
                contacts: '',
                WeChat: '',
                email: ''
              }
            } else {
              this.$message.error(res.data.msg)
            }
          })
        }
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/meetSession/index.vue